module.exports = __webpack_public_path__ + "static/vid2-e992d0ec2ae77789d8454f03b701892c.mp4";